module.exports = __webpack_public_path__ + "img/Slice1-min.5a49ac36.png";